import { CITIES } from '@spa/shared/constants/locationTypes';
import { locationTranslation } from '@spa/shared/utils/location';
import { NEIGHBOURHOODS, UNIVERSITIES } from '@spa/shared/constants/locationTypes';

export const getCountryTranslation = (
  locale = 'en',
  {
    _embedded: {
      country: {
        metadata: {
          name_translations: { items }
        }
      }
    }
  }
) => {
  const { text } = items.find(({ locale_code }) => locale_code === locale) || {};

  return text;
};

export const getCountrySlug = ({
  _embedded: {
    country: {
      configuration: { slug }
    }
  }
}) => slug;

export const getCityTranslation = (
  locale,
  {
    metadata: {
      name_translations: { items }
    }
  }
) => {
  const { text } =
    items.find(({ locale_code }) => locale_code === locale) ||
    items.find(({ locale_code }) => locale_code === 'en_GB') ||
    {};

  return text;
};

export const getCityFromLocation = ({ type, city, ...location }) => {
  if (type === CITIES) {
    return location;
  }

  return city;
};

export const getCountrySlugFromLocation = (location = {}) => {
  const city = getCityFromLocation(location);

  return city ? getCountrySlug(city) : undefined;
};

export const getCityWithNeighbourhoodOrUniversity = (locale, location, cityTranslation, t) => {
  if (location?.type === NEIGHBOURHOODS) {
    return `${locationTranslation(location, locale)}, ${cityTranslation}`;
  }

  if (location?.type === UNIVERSITIES) {
    return `${cityTranslation} ${t('close to')} ${locationTranslation(location, locale)}`;
  }

  return cityTranslation;
};
